import { api } from "@/lib/api";
import { toast } from "sonner";

let resolver = null;
export const registerDupResolver = (fn) => { resolver = fn; };

// POST con controllo doppioni: su 409 apre la finestra di risoluzione. Ritorna null se l'utente salta.
export const postWithDupCheck = async (url, body) => {
  try {
    return await api.post(url, body);
  } catch (e) {
    const det = e?.response?.data?.detail;
    if (e?.response?.status !== 409 || !det?.duplicates || !resolver) throw e;
    const choice = await resolver({ kind: det.kind, nuovo: body, duplicates: det.duplicates });
    if (!choice || choice.action === "skip") {
      toast.info("Caricamento annullato");
      return null;
    }
    return api.post(url, { ...body, on_duplicate: choice.action, overwrite_id: choice.target_id || null });
  }
};
